const Footer = () => {
  const year = new Date().getFullYear();

  const solutionLinks = [
    { name: 'ServiceDesk Plus', href: '#solutions' },
    { name: 'Endpoint Central', href: '#solutions' },
    { name: 'AD Yönetimi', href: '#solutions' },
    { name: 'IT Monitoring', href: '#solutions' },
    { name: 'AutomMate', href: '#solutions' },
    { name: 'Zoho ONE', href: '#solutions' },
  ];

  const companyLinks = [
    { name: 'Hakkımızda', href: '#about' },
    { name: 'Çözümler', href: '#solutions' },
    { name: 'Neden WOTECH', href: '#why' },
    { name: 'Referanslar', href: '#testimonials' },
    { name: 'İletişim', href: '#contact' },
    { name: 'KVKK', href: '#' },
  ];

  const socialLinks = [
    { icon: 'ri-linkedin-fill', href: 'https://linkedin.com/company/wotech', label: 'LinkedIn' },
    { icon: 'ri-twitter-x-fill', href: 'https://twitter.com/wotech', label: 'Twitter' },
    { icon: 'ri-youtube-fill', href: 'https://youtube.com/@wotech', label: 'YouTube' },
  ];

  return (
    <footer className="bg-[#0F172A]">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <a href="#" className="flex items-center gap-2.5 mb-5 cursor-pointer w-fit">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#0891B2]">
                <i className="ri-cpu-line text-white text-lg"></i>
              </div>
              <span className="text-xl font-extrabold text-white tracking-tight font-heading">
                WO<span className="text-[#0891B2]">TECH</span>
              </span>
            </a>
            <p className="text-sm text-[#94A3B8] leading-relaxed max-w-sm mb-6 font-body">
              ManageEngine ve AutomMate Türkiye Partneri. Kurumsal IT çözümlerinde{' '}
              <strong className="text-white">12+ yıllık deneyim</strong> ve{' '}
              <strong className="text-white">400+ başarılı proje</strong> ile yanınızdayız.
            </p>
            <div className="flex gap-3">
              {socialLinks.map((s, i) => (
                <a
                  key={i}
                  href={s.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 border border-white/10 text-[#94A3B8] hover:text-white hover:bg-[#0891B2] hover:border-[#0891B2] transition-all duration-200 cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Solutions */}
          <div>
            <h4 className="text-xs font-bold text-white mb-5 uppercase tracking-widest font-heading">
              <a href="#solutions" className="hover:text-[#0891B2] transition-colors cursor-pointer">Çözümler</a>
            </h4>
            <ul className="space-y-2.5">
              {solutionLinks.map((item, i) => (
                <li key={i}>
                  <a href={item.href} className="text-sm text-[#94A3B8] hover:text-white transition-colors font-body cursor-pointer">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs font-bold text-white mb-5 uppercase tracking-widest font-heading">
              <a href="#about" className="hover:text-[#0891B2] transition-colors cursor-pointer">Kurumsal</a>
            </h4>
            <ul className="space-y-2.5">
              {companyLinks.map((item, i) => (
                <li key={i}>
                  <a href={item.href} className="text-sm text-[#94A3B8] hover:text-white transition-colors font-body cursor-pointer">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* CTA strip */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 py-6 px-6 rounded-xl bg-[#0891B2]/10 border border-[#0891B2]/20 mb-8">
          <p className="text-sm text-[#94A3B8] font-body">
            <strong className="text-white">IT dönüşümünüze hazır mısınız?</strong> Uzmanlarımızla hemen görüşün.
          </p>
          <a href="#contact" className="px-5 py-2.5 bg-[#0891B2] text-white text-sm font-semibold rounded-lg hover:bg-[#0E7490] transition-all duration-200 whitespace-nowrap cursor-pointer font-body flex-shrink-0">
            Demo Talep Et
          </a>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-3 pt-6 border-t border-white/[0.06]">
          <p className="text-xs text-[#475569] font-body">© {year} WOTECH. Tüm hakları saklıdır.</p>
          <a href="https://readdy.ai/?origin=logo" target="_blank" rel="nofollow noopener noreferrer" className="text-xs text-[#475569] hover:text-[#0891B2] transition-colors font-body cursor-pointer">
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
